module.exports = __webpack_public_path__ + "static/media/teams.8ebc6e8d.png";